export enum BillingPeriod {
    Monthly = 1,
    Quarterly = 2,
    SemiAnnually = 3,
    Annually = 4
}
